import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { LmsService } from "../../_Lms/services/lms.service";
import { LosService } from "../../_LOS/services/los.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { DialogService } from "../../Shared/dialog.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";

declare var $: any;

import * as moment from "moment";
import { MasterService } from "../../Shared/app.Masters.Service";

@Component({
    selector: "app-aupayment",
    templateUrl: "./aupayment.component.html",
    styleUrls: ["./aupayment.component.scss"],
    standalone: false
})
export class AupaymentComponent implements OnInit {
  @ViewChild(MatPaginator) paginatorRef!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  selectedPayee: any = null;
  selectedStatusPayee: any = null;
  StatusDebitTo: any = null;
  CreditToList: any[] = [];
  DebitToList: any[] = [];
  initiatedPayees: any[] = [];
  currentUser: any;
  Id: number;
  PAYEE: any = "";
  DebitTo: any = null;
  CreditTo: any = null;
  Account_Type: string = "";
  PayeeName: string;
  BankName: string;
  BankBranch: string;
  AccountNo: string;
  IFSCCode: string;
  Amount: any;
  PaymentMode: string = "";
  VoucherNarration: string = "";
  showSpinner: boolean = false;
  tab: any = "initiatePayment";
  updateBtn: boolean = false;
  saveBtn: boolean = true;
  dataInitiateSource: any;
  dataPayeeSource: any;
  PayeeData: any[] = [];
  StatusData: any[] = [];
  GSTModel: any = {};
  AccountHeadForGST: any[] = [];
  stateDropdown: any[] = [];
  slabList: any[] = [];
  Tax_Slab_Data: any[] = [];
  empBranchDropdown: any[] = [];
  BranchId: any = null;
  TaxTotalAmount: any;
  Bind_Voucher: any = 1;
  creditDebitAmount: any;
  displayedInitiateColumns: string[] = [
    "Id",
    "DebitTo",
    "Payee_Name",
    "Account_No",
    "Bank_Name",
    "IFSC_Code",
    "amount",
    "paymentMethodName",
    "Action",
  ];
  Bank_Verification: boolean = true;
  Bank_VerificationKeys: any;
  isExistingCustomer: boolean = false;
  BankForm: boolean = true;
  APIResponse: any = {
    DoucumentNumber: "",
    Full_name: "",
    IsVerified: "",
    category: "",
  };
  displayedPayeeColumns: string[] = [
    "Payee_Id",
    "Payee_Name",
    "Bank_Name",
    "Bank_Branch",
    "Account_No",
    "IFSC_Code",
    "Account_Type",
    "Action",
  ];
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  TaxSlab1: any[];
  GSTAmountModel: { CGST: any; SGST: any; IGST: any; TotalTax: any };
  // status
  Type = "AuthorizedOn";
  Status = "PAID";
  dataStatusSource: any;
  ToDate: any = new Date();
  FromDate: any = new Date();
  displayedSourceColumns: string[] = [
    "Id",
    "DebitTo",
    "Payee_Name",
    "Bank_Name",
    "Account_No",
    "IFSC_Code",
    "paymentMethodName",
    "amount",
    "Status",
    "CreatedBy",
    "CreatedOn",
    "AuthorizedOn",
  ];
  constructor(
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private _MasterService: MasterService,
    private lmsService: LmsService,
    private losService: LosService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private dialog: DialogService
  ) {}

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("AU Payment");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.LMS_Get_OtherPayment_AUBank();
    this.GetAccAccountingList();
    this.Get_TaxSlab_Dropdown();
    this.Get_AccountForGST_Dropdown();
    this.GetStateDropdown();
    this.Get_Master_Payee_Detail();

    this.Get_EmployeeBranchForDropdown();
  }

  changeTab(tab: any) {
    this.PaymentMode = "";
    this.VoucherNarration = "";

    if (tab !== this.tab) {
      this.tab = tab;
      $(".filterInput").val("");
      if (tab === "initiatePayment") {
        // this.Get_Master_Payee_Detail();
        this.LMS_Get_OtherPayment_AUBank();
        this.resetInputs();
      } else if (tab === "status") {
        this.resetInputs();
        // this.Get_Master_Payee_Detail();
      } else if (tab === "payeTab") {
        this.GetAccAccountingList();
        this.resetInputs();
        this.Get_Master_Payee_Detail();
      }
    }
  }
  onVerifiedBankDetail() {
    this.showSpinner = true;
    var model = {
      KYC_DocNumber: this.AccountNo,
      SMS_URL: this.Bank_VerificationKeys.SMS_URL,
      IFSC: this.IFSCCode,
      Key: this.Bank_VerificationKeys.Key,
    };
    this._MasterService.Get_KYC_Verification(model).subscribe((res: any) => {
      var APIResult = res;
      var data = {
        KYC_Verification: {
          DoucumentNumber: model.KYC_DocNumber,
          DocumentId: 0,
          IsVerified: APIResult.success,
          APIURL: APIResult.APIURL,
          APIRequest: APIResult.request,
          APIResponse: APIResult.response,
          APIStatus: APIResult.status_code,
          LoginUserId: this.currentUser.userId,
          SenderId: this.Bank_VerificationKeys.VendorName,
        },
      };

      this._MasterService
        .Save_Customer_Kyc_Verification({ JSON: JSON.stringify(data) })
        .subscribe((Save_res: any) => {
          if (Save_res[0].CODE == 0) {
            this.showSpinner = false;
            //if (APIResult.success == true) {
            this.BankForm = false;
            this.PayeeName = JSON.parse(
              data.KYC_Verification.APIResponse
            ).data.full_name;
            this.BankName = JSON.parse(
              data.KYC_Verification.APIResponse
            ).data.ifsc_details.bank_name;
            this.BankBranch = JSON.parse(
              data.KYC_Verification.APIResponse
            ).data.ifsc_details.branch;
            console.log("APIResult", this.PayeeName);
            console.log("APIResult", this.BankName);
            console.log("APIResult", this.BankBranch);

            this.APIResponse = {
              KYC_DocId: 0,
              DoucumentNumber: this.AccountNo,
              // DoucumentNumber: this.verify_DocNumber.toUpperCase().substr(0, 3) + MaskingDoc + this.verify_DocNumber.toUpperCase().substr(this.verify_DocNumber.length - 3),

              Full_name: JSON.parse(data.KYC_Verification.APIResponse).data
                .full_name,

              IsVerified: JSON.parse(data.KYC_Verification.APIResponse).success,
              // address: JSON.parse(data.KYC_Verification.APIResponse).data
              //   .ifsc_details.address,
              // mobile: JSON.parse(data.KYC_Verification.APIResponse).data
              //   .ifsc_details.contact,
              bank_name: JSON.parse(data.KYC_Verification.APIResponse).data
                .ifsc_details.bank_name,
              // account_exists: JSON.parse(data.KYC_Verification.APIResponse).data
              //   .ifsc_details.account_exists,
              // message: JSON.parse(data.KYC_Verification.APIResponse).message,
              // micr: JSON.parse(data.KYC_Verification.APIResponse).data
              //   .ifsc_details.micr,
              branch: JSON.parse(data.KYC_Verification.APIResponse).data
                .ifsc_details.branch,
              ifsc: this.IFSCCode,
              // state: JSON.parse(data.KYC_Verification.APIResponse).data
              //   .ifsc_details.state,
              // district: JSON.parse(data.KYC_Verification.APIResponse).data
              //   .ifsc_details.district,
              // city: JSON.parse(data.KYC_Verification.APIResponse).data
              //   .ifsc_details.city,
              // rtgs: JSON.parse(data.KYC_Verification.APIResponse).data
              //   .ifsc_details.rtgs,
              // neft: JSON.parse(data.KYC_Verification.APIResponse).data
              //   .ifsc_details.neft,
              // imps: JSON.parse(data.KYC_Verification.APIResponse).data
              //   .ifsc_details.imps,
              // Remark: JSON.parse(data.KYC_Verification.APIResponse).data
              //   .remarks,

              // message_code: JSON.parse(data.KYC_Verification.APIResponse)
              //   .message_code,
            };

            //} else {
            //  //this.CustomerKYCDoc[this.record].KYC_IsVerified = 0;
            //  this.onCloseBankModel();
            //  this.snackBar.openFromComponent(SnackbarComponent, {
            //    data: "YOUR Bank Account NOT VALID !!!",
            //    ...this.configSuccess,
            //  });
            //  return;
            //}
          }
        });
    });
  }

  updateToken() {
    this.showSpinner = true;
    this.lmsService.AU_Payment_authTokenGenerate({}).subscribe((res: any) => {
      console.log("res", res);
      if (res.length > 0) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
      }
    });
    this.showSpinner = false;
  }

  openModal() {
    this._MasterService
      .Get_Sms_Configration({ Step_Name: "Bank_Verification" })
      .subscribe((res: any) => {
        this.showSpinner = false;
        if (res.length == 0) {
          this.Bank_Verification = false;
        } else {
          this.Bank_Verification = true;
          this.Bank_VerificationKeys = res[0];
        }
        // this.customerModel = {
        //   ApplicationId: this.applicationId,
        //   Customer_Type: "",
        //   Customer_Relation: "",
        //   RegTotalYearsOnAddress: "",
        //   RegAddressRentBuy: "",
        //   RegNearstBranchDistance_KM: "",
        //   CorpTotalYearsOnAddress: "",
        //   CorpAddressRentBuy: "",
        //   CorpNearstBranchDistance_KM: "",
        //   BusinessType: "",
        //   BusinessCategory: "",
        //   Customer_Profile: "",
        //   Customer_Category: "",
        //   Customer_SubCategory: "",
        //   Customer_Natureofwork: "",
        // };
        this.isExistingCustomer = false;
      });

    $("#payeeModel").modal("show");
  }
  GetAccAccountingList() {
    this.lmsService.GetAccAccountingList({}).subscribe((res: any) => {
      this.DebitToList = res?.filter(
        (item: any) => item.LoanChargeable?.toLowerCase() === "no"
      );
    });
  }
  // initiate table
  LMS_Get_OtherPayment_AUBank() {
    this.showSpinner = true;
    this.lmsService
      .LMS_Get_OtherPayment_AUBank({})
      .subscribe((response: any) => {
        // this.JsonData = JSON.parse(JSON.stringify(response));
        this.dataInitiateSource = new MatTableDataSource(response);
        this.dataInitiateSource.paginator = this.paginatorRef; // Assign paginator after datasource
        this.dataInitiateSource.sort = this.sort;
        this.showSpinner = false;
      });
  }
  EStatusCheckModel(row: any) {
    this.showSpinner = true;
    var AURequestJson = {
      TransactionEnquiryRequest: {
        uniqueRequestId: row.uniqueRequestId || "",
        transactionRequestId: "",
        batchNo: row.batchNo || "",
        transactionRefNo: "",
        corporateCode: "",
      },
    };
    var json = {
      LoanId: "0",
      CreatedBy: this.currentUser.userId,
      Id: row.Id,
      batchNo: row.batchNo || "",
    };

    console.log("AURequestJson", JSON.stringify(AURequestJson));

    console.log("json", JSON.stringify(json));
    this._MasterService
      .AU_Payment_Enquiry({
        AURequestJson: JSON.stringify(AURequestJson),
        Json: JSON.stringify(json),
      })
      .subscribe((res: any) => {
        if (res.status != "SUCCESS") {
          console.log("res", res);
          this.showSpinner = false;
          this.LMS_Get_OtherPayment_AUBank();
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res.status,
            ...this.configSuccess,
          });
        } else {
          this.showSpinner = false;
          this.LMS_Get_OtherPayment_AUBank();
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res.status,
            ...this.configSuccess,
          });
        }
      });
  }
  // search filter
  applyFilter(filterValue: string) {
    this.dataInitiateSource.filter = filterValue.trim().toLowerCase();
    this.dataPayeeSource.filter = filterValue.trim().toLowerCase();
  }
  onAmountChange() {
    let SelectBranch, StateId;
    if (
      this.DebitTo &&
      this.DebitTo.GSTEnable &&
      this.DebitTo.GSTEnable.toLowerCase() === "yes"
    ) {
      $("#GSTModalWindow").modal("show");
      $("#GSTModalWindow").css("z-index", "1050");
      this.GSTModel = {
        Slab_Tax: "",
        AccountHeadId: "",
        PartyType: "Existing_Party",
        StateId: "",
        Charge_head: "",
        Amount: this.Amount,
      };
      SelectBranch = this.empBranchDropdown.filter(
        (x) => x.BranchId == this.BranchId
      );
    } else {
      this.creditDebitAmount = parseFloat(this.Amount);
      this.GetDebitAccount();
    }
  }
  GetDebitAccount() {
    this._MasterService
      .Get_Disbursment_Accounts_By_Tag({
        LoginUserId: this.currentUser.userId,
        Account_Tag: "Bank",
        Voucher_Date: new Date(),
        Amount: this.creditDebitAmount,
      })
      .subscribe((res: any) => {
        this.CreditToList = res.filter((x) => x.IsAuPaymentAccount == 1);
      });
  }
  onChangebranch(data: any) {
    let BranchId: string;
    let BranchData = this.empBranchDropdown.filter(
      (x) =>
        x.Branch_Name?.trim().toLowerCase() ===
        data.Branch_Name?.trim().toLowerCase()
    );

    if (BranchData.length > 0) {
      BranchId = BranchData[0].AccountId;

      // Save Branch Name inside GSTModel
      if (!data.GSTModel) {
        data.GSTModel = {};
      }
      data.GSTModel.Branch_Name = BranchData[0].Branch_Name;
    } else {
      BranchId = "";
      data.Amount = "";
      data.Branch_Name = "";
      data.TaxSlab1 = [];
      data.GSTModel = {};

      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Branch Name not found",
        ...this.configSuccess,
      });
      return;
    }
  }
  resetInputs() {
    this.Account_Type = "";
    this.selectedPayee = null;
    this.selectedStatusPayee = null;
    this.BranchId = null;
    this.BankName = "";
    this.CreditTo = null;
    this.AccountNo = "";
    this.IFSCCode = "";
    this.Status = "PAID";
    this.Type = "AuthorizedOn";
    this.ToDate = new Date();
    this.FromDate = new Date();
    this.Amount = null;
    this.PaymentMode = "";
    this.VoucherNarration = "";
  }
  payeeReset() {
    this.IFSCCode = "";
    this.PayeeName = "";
    this.BankName = "";
    this.BankBranch = "";
    this.Account_Type = "";
  }

  openGstModal() {
    const modalBtn = document.getElementById("openGstModalBtn");
    if (modalBtn) modalBtn.click();
  }
  OnCloseGSTModal() {
    $("#GSTModalWindow").modal("hide");
    this.GSTModel = {};
    this.Tax_Slab_Data = [];
    this.GetDebitAccount();
  }

  Get_AccountForGST_Dropdown() {
    this._MasterService
      .Get_AccountForGST_Dropdown({ LoginUserId: this.currentUser.userId })
      .subscribe((res: any) => {
        this.AccountHeadForGST = res;
      });
  }
  GetStateDropdown() {
    this.losService.GetStateDropdown({}).subscribe((res: any) => {
      this.stateDropdown = res;
    });
  }

  Get_TaxSlab_Dropdown() {
    this.lmsService.Get_TaxSlab_Dropdown({}).subscribe((res: any) => {
      this.slabList = res;
      this.slabList = this.slabList.reduce((acc, current) => {
        const x = acc.find(
          (item) => item.TaxSlab_Name === current.TaxSlab_Name
        );
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    });
  }

  onPartyTypeChange() {
    if (this.GSTModel.PartyType == "Existing_Party") {
      this.GSTModel = {
        Slab_Tax: "",
        AccountHeadId: "",
        PartyType: this.GSTModel.PartyType,
        Acc_GSTNo: this.GSTModel.GST_No,
        Amount: this.GSTModel.Amount,
        TranType: this.GSTModel.TranType,
        StateId: this.GSTModel.StateId,
      };
    } else {
      //StateId : this.BranchData.StateId,
      this.GSTModel = {
        PartyType: this.GSTModel.PartyType,
        Slab_Tax: "",
        AccountHeadId: "",
        Customer: "",
        Acc_GSTNo: "",
        StateId: "",
        Amount: this.GSTModel.Amount,
        TranType: this.GSTModel.TranType,
      };
    }
  }

  onAccountHeadChange() {
    let data = this.AccountHeadForGST.filter(
      (item) => item.AccountId == this.GSTModel.AccountHeadId
    );

    this.GSTModel = {
      AccountHeadId: this.GSTModel.AccountHeadId,
      Slab_Tax: this.GSTModel.Slab_Tax,
      Acc_GSTNo: data[0].Acc_GSTNo,
      StateId: data[0].StateId,
      HSNCode: data[0].HSNCode,
      Account_Name: data[0].Account_Name,
      PartyType: this.GSTModel.PartyType,
      Amount: this.GSTModel.Amount,
    };
    /*this.AccountHeadForGST.forEach((obj: any) => {
      obj.Amount = '';
    });*/
  }

  saveGSTDetails() {
    $("#GSTModalWindow").modal("hide");

    this.lmsService
      .Get_TaxSlab_Details({ TaxSlab: this.GSTModel.Slab_Tax })
      .subscribe((res: any) => {
        const Br_StateId = this.empBranchDropdown.find(
          (x) => (x.BranchId = this.BranchId)
        ).StateId;
        const BranchName = this.empBranchDropdown.find(
          (x) => (x.BranchId = this.BranchId)
        ).Branch_Name;

        if (Br_StateId == this.GSTModel.StateId) {
          this.Tax_Slab_Data = res.filter(
            (item) =>
              item.TaxType == "Input" && item.IsInterState == "With in State"
          );
        } else {
          this.Tax_Slab_Data = res.filter(
            (item) =>
              item.TaxType == "Input" && item.IsInterState == "Inter state"
          );
        }

        this.GSTModel.TaxType = this.Tax_Slab_Data[0].TaxType;
        // const isIntraState = Br_StateId == this.GSTModel.BranchId;

        // this.Tax_Slab_Data = res.filter((item: any) =>
        //   item.TaxType === "Output" &&
        //   item.IsInterState === (isIntraState ? "With in State" : "Inter state")
        // );

        let totalGSTAmount = 0;

        this.Tax_Slab_Data.forEach((x: any) => {
          x.BranchName = BranchName;
          x.Amount = this.GSTModel.Amount;
          x.TaxAmount = parseFloat(
            (
              (parseFloat(this.GSTModel.Amount) * parseFloat(x.TaxSlab_Rate)) /
              100
            ).toFixed(2)
          );

          x.TypeCGST = x.TaxSlab_Type.includes("CGST");
          x.TypeSGST = x.TaxSlab_Type.includes("SGST");
          x.TypeIGST = x.TaxSlab_Type.includes("IGST");

          totalGSTAmount += x.TaxAmount;
        });

        this.TaxTotalAmount = totalGSTAmount; // This is your final total GST
        this.creditDebitAmount =
          parseFloat(this.Amount) + parseFloat(this.TaxTotalAmount);
        // Optionally, you can assign it to a model:
        this.GSTAmountModel = {
          CGST: this.Tax_Slab_Data.find((x) => x.TypeCGST)?.TaxAmount || 0,
          SGST: this.Tax_Slab_Data.find((x) => x.TypeSGST)?.TaxAmount || 0,
          IGST: this.Tax_Slab_Data.find((x) => x.TypeIGST)?.TaxAmount || 0,
          TotalTax: totalGSTAmount,
        };
        this.GetDebitAccount();
        console.log("Tax Slabs:", this.Tax_Slab_Data);
        console.log("Total GST:", this.TaxTotalAmount);
        console.log("GSTAmountModel:", this.GSTAmountModel);
      });
  }

  Get_EmployeeBranchForDropdown() {
    this._MasterService
      .Get_EmployeeBranchForDropdown({ EmployeeId: this.currentUser.userId })
      .subscribe((res: any) => {
        this.empBranchDropdown = res;
      });
  }

  onPayeeSelect() {
    this.AccountNo = this.selectedPayee.Account_No;
    this.BankName = this.selectedPayee.Bank_Name;
    this.IFSCCode = this.selectedPayee.IFSC_Code;
    this.PayeeName = this.selectedPayee.Payee_Name;
  }

  closeModal() {
    // this.Id = null;
    this.Account_Type = "";
    this.PayeeName = "";
    this.BankName = "";
    this.BankBranch = "";
    this.AccountNo = "";
    this.IFSCCode = "";
    this.saveBtn = true;
    this.updateBtn = false;
    $("#payeeModel").modal("hide");
  }
  removePayee(row) {
    this.dialog
      .openConfirmDialog("Are you sure you want to delete?")
      .afterClosed()
      .subscribe((dialogResult) => {
        if (!dialogResult) {
          return;
        }
        this.showSpinner = true;
        this._MasterService
          .Delete_Master_Payee_Detail({
            Payee_Id: row.Payee_Id,
            LoginUserId: this.currentUser.userId,
          })
          .subscribe((response: any) => {
            console.log("Remove_Master_Payee_Detail", response);
            if (response.length > 0) {
              this.showSpinner = false;
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: response[0].MSG,
                ...this.configSuccess,
              });
              this.Get_Master_Payee_Detail();
            } else {
              this.showSpinner = false;
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: response[0].MSG,
                ...this.configSuccess,
              });
            }
          });
      });
  }
  editPayeeInfo(row: any) {
    this.Id = row.Payee_Id;
    this.PayeeName = row.Payee_Name;
    this.BankName = row.Bank_Name;
    this.BankBranch = row.Bank_Branch;
    this.AccountNo = row.Account_No;
    this.IFSCCode = row.IFSC_Code;
    this.Account_Type = row.Account_Type;
    this.saveBtn = false;
    this.updateBtn = true;
    $("#payeeModel").modal("show");
  }

  Get_Master_Payee_Detail() {
    this.showSpinner = true;
    this._MasterService.Get_Master_Payee_Detail().subscribe((response: any) => {
      console.log("get_master_payee_log", response);
      this.PayeeData = JSON.parse(JSON.stringify(response)); // Backup
      console.log("PayeeData", this.PayeeData);
      this.dataPayeeSource = new MatTableDataSource(response);
      this.dataPayeeSource.paginator = this.paginatorRef; // Assign paginator after datasource
      this.dataPayeeSource.sort = this.sort;
      this.showSpinner = false;
    });
  }

  onSavePayeeDetail() {
    this.showSpinner = true;
    this._MasterService
      .Save_Master_Payee_Detail({
        Payee_Id: this.Id, // If present, will update; if not, will add
        Payee_Name: this.PayeeName,
        Bank_Name: this.BankName,
        Bank_Branch: this.BankBranch,
        Account_No: this.AccountNo.toString(),
        IFSC_Code: this.IFSCCode,
        Account_Type: this.Account_Type,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((response: any) => {
        this.showSpinner = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: response[0].MSG,
          ...this.configSuccess,
        });
        if (response[0].CODE == 0) {
          this.closeModal();
        }
        this.Get_Master_Payee_Detail();
      });
  }
  onInitaite() {
    console.log("Tax_Slab_Data", this.Tax_Slab_Data);
    this.showSpinner = true;
    const now = new Date();
    var FinalVoucher = {
      DealerVoucher: {},
      CustomerVoucher: {},
    };
    const Voucher = {
      VoucherId: null,
      Voucher_Type: "Payment",
      Voucher_Sub_Type: "Accounting",
      Voucher_Tag: "Bank",
      Voucher_Date: now.toISOString(),
      DRAccountId: this.CreditTo?.AccountId,
      Voucher_Mode_of_Payment: this.PaymentMode,
      Voucher_Total_Credit_Amount: this.creditDebitAmount,
      Voucher_Total_Debit_Amount: this.creditDebitAmount,
      Voucher_Total_Tax: this.TaxTotalAmount ? this.TaxTotalAmount : null,
      Voucher_Narration: this.VoucherNarration,
      Voucher_Cheque_No: null,
      Voucher_Cheque_Date: null,
      Voucher_Bank_Name: null,
      Voucher_Cheque_Clear_Date: null,
      Voucher_E_Transaction_Date: now.toISOString(),
      Voucher_E_Ref_No: "",
      Voucher_ReceiptNo_Book: null,
      Voucher_ReceiptDate: null,
      LoginUserId: this.currentUser.userId,
      Voucher_No: "",
    };
    const Voucher_Detail = [
      {
        VoucherId: 0,
        CaseNo: "",
        CustomerId: "",
        Is_LOSAppliaction: "",
        ChargeHeadId: "",
        ChargeHeadCategory: this.DebitTo?.Name || "",
        AccountId: this.DebitTo?.Id || "",
        BranchId: this.BranchId,
        TranType: "DR",
        IsTax: 0,
        Tax_Per: 0,
        Amount: this.Amount,
        Bind_Voucher: this.Bind_Voucher + 1,
        Type: "",
        GST_Type: "",
        GST_No: "",
        Party_AccountName: "",
        HSN_Code: "",
        Slab_Name: "",
      },
    ];
    if (this.Tax_Slab_Data.length > 0) {
      this.Tax_Slab_Data.forEach((x: any) => {
        Voucher_Detail.push({
          VoucherId: 0,
          CaseNo: "",
          CustomerId: "",
          Is_LOSAppliaction: "",
          ChargeHeadId: "",
          ChargeHeadCategory: x.Account_Name,
          AccountId: x.AccountId,
          BranchId: this.BranchId,
          TranType: "DR",
          IsTax: 1,
          Tax_Per: x.TaxSlab_Rate,
          Amount: x.TaxAmount,
          Bind_Voucher: Voucher_Detail[0].Bind_Voucher,
          Type: "",
          GST_Type: "",
          GST_No: "",
          Party_AccountName: "",
          HSN_Code: "",
          Slab_Name: "",
        });
        Voucher_Detail[0].Type = "Output";
        Voucher_Detail[0].GST_Type = this.GSTModel.PartyType;
        Voucher_Detail[0].GST_No = this.GSTModel.Acc_GSTNo;
        Voucher_Detail[0].Party_AccountName =
          this.GSTModel.PartyType == "Existing_Party"
            ? this.AccountHeadForGST.find(
                (x) => x.AccountId == this.GSTModel.AccountHeadId
              ).Account_Name
            : this.GSTModel.Customer;
        Voucher_Detail[0].HSN_Code = this.GSTModel.HSNCode;
        Voucher_Detail[0].Slab_Name = x.TaxSlab_Name;
      });
    }
    Voucher_Detail.push({
      VoucherId: 0,
      CaseNo: "",
      CustomerId: "",
      Is_LOSAppliaction: "0",
      ChargeHeadId: "",
      ChargeHeadCategory: this.CreditTo?.Account_Name,
      AccountId: this.CreditTo?.AccountId,
      BranchId: this.BranchId,
      TranType: "CR",
      IsTax: 0,
      Tax_Per: 0,
      Amount: this.creditDebitAmount,
      Bind_Voucher: this.Bind_Voucher,
      Type: "",
      GST_Type: "",
      GST_No: "",
      Party_AccountName: "",
      HSN_Code: "",
      Slab_Name: "",
    });
    console.log("Voucher_Detail data", Voucher_Detail);
    let _finalData = {
      Voucher: this.dataSharingService.cleanObject({
        ...Voucher,
      }),
      Voucher_Detail: Voucher_Detail,
    };

    console.log("_finalData :", _finalData);
    FinalVoucher.CustomerVoucher = _finalData;
    var json = {
      CreatedBy: this.currentUser.userId,
      Voucher_Json: JSON.stringify(FinalVoucher),
      Account_Id_DR: this.DebitTo?.Id,
      Account_Id_CR: this.CreditTo?.AccountId,
      PayeeId: this.selectedPayee.Payee_Id,
    };

    var benename = this.selectedPayee.Payee_Name;
    const randomStr = this.generateRandomString();
    var AURequestJson = {
      TransactionCreationRequest: {
        uniqueRequestId: "",
        corporateCode: "",
        corporateProductCode: "",
        transactionDetails: [
          {
            paymentMethodName: this.PaymentMode,
            remitterAccountNo: this.CreditTo?.AccountNo,
            // amount: this.SelectPayData.Amount.toString(),
            amount: this.creditDebitAmount,

            ifscCode:
              this.PaymentMode == "Internal Fund Transfer"
                ? ""
                : this.selectedPayee?.IFSC_Code.toUpperCase(),
            payableCurrency: "INR",
            beneAccNo: this.selectedPayee?.Account_No,
            beneCode: "",
            valueDate: "",
            beneName: benename,
            remarks: this.VoucherNarration,
            transactionRefNo: randomStr,
            paymentInstruction: "Other Payment",
            //"email": this.customerDetail.CompanyMailId ? this.customerDetail.CompanyMailId : '',
            //"phoneNo": this.customerDetail.CompanyPhoneNo ? this.customerDetail.CompanyPhoneNo : ''
            email: "",
            phoneNo: "",
          },
        ],
      },
    };
    console.log("AURequestJson", JSON.stringify(AURequestJson));
    console.log("json", JSON.stringify(json));
    this._MasterService
      .AU_Payment_Initiate({
        AURequestJson: JSON.stringify(AURequestJson),
        Json: JSON.stringify(json),
      })
      .subscribe((res: any) => {
        if (res.status != "00") {
          console.log("res", res);
          this.showSpinner = false;
          this.LMS_Get_OtherPayment_AUBank();
          this.resetInputs();
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res.MSG,
            ...this.configSuccess,
          });
        } else {
          this.showSpinner = false;
          this.LMS_Get_OtherPayment_AUBank();
          this.resetInputs();
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res.MSG,
            ...this.configSuccess,
          });
        }
      });

    this.showSpinner = false;
  }
  generateRandomString(length: number = 10): string {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }
  exportExcelInitiate(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" 
            xmlns:x="urn:schemas-microsoft-com:office:excel" 
            xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <!--[if gte mso 9]>
            <xml>
              <x:ExcelWorkbook>
                <x:ExcelWorksheets>
                  <x:ExcelWorksheet>
                    <x:Name>{worksheet}</x:Name>
                    <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                  </x:ExcelWorksheet>
                </x:ExcelWorksheets>
              </x:ExcelWorkbook>
            </xml>
          <![endif]-->
        </head>
        <body>
          <table>{table}</table>
        </body>
      </html>`;

    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));

    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById("exportInitiate") as HTMLTableElement;
    if (!table) {
      console.error("Table not found!");
      return;
    }

    const ctx = { worksheet: "Initiate Data", table: table.innerHTML };
    const downloadLink = document.createElement("a");

    downloadLink.href = uri + base64(format(template, ctx));
    downloadLink.download = "Initiate_Data.xls";
    downloadLink.click();
  }
  exportPayee(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" 
            xmlns:x="urn:schemas-microsoft-com:office:excel" 
            xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <!--[if gte mso 9]>
            <xml>
              <x:ExcelWorkbook>
                <x:ExcelWorksheets>
                  <x:ExcelWorksheet>
                    <x:Name>{worksheet}</x:Name>
                    <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                  </x:ExcelWorksheet>
                </x:ExcelWorksheets>
              </x:ExcelWorkbook>
            </xml>
          <![endif]-->
        </head>
        <body>
          <table>{table}</table>
        </body>
      </html>`;

    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));

    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById("exportPayee") as HTMLTableElement;
    if (!table) {
      console.error("Table not found!");
      return;
    }

    const ctx = { worksheet: "Payee Data", table: table.innerHTML };
    const downloadLink = document.createElement("a");

    downloadLink.href = uri + base64(format(template, ctx));
    downloadLink.download = "Payee Data.xls";
    downloadLink.click();
  }
  // Status
  onTypeChange(event: any) {
    if (this.Type === "AuthorizedOn") {
      this.Status = "PAID";
    } else {
      this.Status = ""; // reset if switching to InitiateOn
    }
  }

  LMS_Get_OtherPayment_Statement() {
    this.showSpinner = true;
    let requestData = {
      FromDate: moment(this.FromDate).format("YYYY-MM-DD").toString(),
      ToDate: moment(this.ToDate).format("YYYY-MM-DD").toString(),
      PayeeId: this.selectedStatusPayee?.Payee_Id,
      DebitTo: this.StatusDebitTo?.Id,
      Status: this.Status,
    };
    this.lmsService
      .LMS_Get_OtherPayment_Statement({ JSON: JSON.stringify(requestData) })
      .subscribe((response: any) => {
        console.log("Response", response);
        if (response.length > 0) {
          this.StatusData = response;
          this.dataStatusSource = new MatTableDataSource(response);
          this.resetInputs();
          this.dataStatusSource.paginator = this.paginatorRef;
          this.dataStatusSource.sort = this.sort;
          this.showSpinner = false;
        } else {
          this.showSpinner = false;
          this.dataStatusSource = null;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No Data Found",
            ...this.configSuccess,
          });
        }
        // this.JsonData = JSON.parse(JSON.stringify(response));
      });
  }
  exportExcelStatus(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" 
            xmlns:x="urn:schemas-microsoft-com:office:excel" 
            xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <!--[if gte mso 9]>
            <xml>
              <x:ExcelWorkbook>
                <x:ExcelWorksheets>
                  <x:ExcelWorksheet>
                    <x:Name>{worksheet}</x:Name>
                    <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                  </x:ExcelWorksheet>
                </x:ExcelWorksheets>
              </x:ExcelWorkbook>
            </xml>
          <![endif]-->
        </head>
        <body>
          <table>{table}</table>
        </body>
      </html>`;

    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));

    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById("exportStatus") as HTMLTableElement;
    if (!table) {
      console.error("Export table not found!");
      return;
    }

    const ctx = {
      worksheet: "Payment Status Report",
      table: table.innerHTML,
    };

    const downloadLink = document.createElement("a");
    downloadLink.href = uri + base64(format(template, ctx));
    downloadLink.download = "Payment_Status_Report.xls";
    downloadLink.click();
  }
}
